export const INBOX_ACCESS = 'inbox.access';
export const PIPELINES_ACCESS = 'pipelines.access';
export const TODOS_ACCESS = 'todos.access';
export const REPORTS_ACCESS = 'reports.access';
export const SETTINGS_ACCESS = 'settings.access';
export const COMMUNICATION_LOGS_ACCESS = 'communication_logs.access';

export const matchPermissionsToRoute = (route) => {
  const tests = [
    { reg: /^\/\d+\/inbox/g, permission: INBOX_ACCESS },
    { reg: /^\/\d+\/pipelines/g, permission: PIPELINES_ACCESS }, //
    { reg: /^\/\d+\/todos/g, permission: TODOS_ACCESS },
    { reg: /^\/\d+\/reports/g, permission: REPORTS_ACCESS },
    { reg: /^\/\d+\/settings/g, permission: SETTINGS_ACCESS },
    { reg: /^\/\d+\/activity\/communication-logs/g, permission: COMMUNICATION_LOGS_ACCESS },
  ];
  const match = tests.filter((n) => route.match(n.reg) || [].length);
  return match ? match[0] : [];
};
